import React from "react";
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAltOutlined';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';

const SentimentIconRating = React.forwardRef(function SentimentIconRating(props, ref) {
  return (
    <span {...props} ref={ref}>
      {props.rating === 5 && <SentimentVerySatisfiedIcon color="success" />}
      {props.rating === 4 && <SentimentSatisfiedAltIcon color="success" />}
      {props.rating === 3 && <SentimentSatisfiedIcon color="warning" />}
      {props.rating === 2 && <SentimentDissatisfiedIcon color="error" />}
      {props.rating === 1 && <SentimentVeryDissatisfiedIcon color="error" />}
    </span>
  );
});

export default SentimentIconRating;
